import { Icon, Text, HStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { useNavigation } from '@react-navigation/native';
import { Button, Pressable } from 'native-base';
import React, { useCallback } from 'react';

import { SignedInNavigationScreenNavigationProp } from '../../../../../routes/types';
import { hideUpdate } from '../../../constants';

export namespace RateManagementHeaderSectionTypes {
  export interface Props {
    isMobile?: boolean;
    title: string;
    handleRefresh: () => void;
  }
}

export const HeaderSection: React.FC<RateManagementHeaderSectionTypes.Props> = ({
  isMobile,
  title,
  handleRefresh,
}) => {
  const navigation = useNavigation<SignedInNavigationScreenNavigationProp>();

  const goBack = useCallback(() => {
    navigation.navigate('AppDrawer', { screen: 'Trading' });
  }, [navigation]);

  const renderUpdateButton = () => {
    if (hideUpdate) {
      return <></>;
    }
    return (
      <Pressable testID="refresh-button" onPress={handleRefresh}>
        <HStack space={1} alignItems="center" justifyContent="center">
          <Text
            py={1.5}
            alignSelf="center"
            textAlign="center"
            color="brand.tertiary.principal"
            variant="semibold"
            fontSize={Typography['fontsize.xs']}>
            ATUALIZAR
          </Text>
          <Icon
            testId="button-icon-refresh"
            name="Refresh"
            size="xxs"
            color={Color['brand.tertiary.principal']}
          />
        </HStack>
      </Pressable>
    );
  };

  return (
    <>
      <HStack
        marginY={!isMobile ? Spacing['inset.sm'] : 0}
        paddingBottom={Spacing['inset.xxxs']}
        justifyContent={'space-between'}
        alignItems={'center'}
        space={Spacing['inline.xxxs']}>
        <HStack justifyContent={'center'} alignItems={'center'} space={Spacing['inset.nano']}>
          <Button
            p={0}
            testID="return-button"
            size={'lg'}
            variant="textLink"
            leftIcon={
              <Icon
                testId="return-button-icon"
                name={'ArrowLeft'}
                size="xxs"
                color={Color['neutral.black']}
              />
            }
            justifyContent="start"
            onPress={goBack}
          />
          <Text
            paddingLeft={Spacing['inset.nano']}
            textAlign={'center'}
            color="brand.primary.principal"
            fontWeight={Typography['fontweight.semibold']}
            fontSize={Typography['fontsize.xl']}
            variant="semibold">
            {title}
          </Text>
        </HStack>

        {renderUpdateButton()}
      </HStack>
    </>
  );
};
